<div class="form-container">
  <h2>{{pageTitle}}</h2>
  <div class="user-form col-md-8 pl0">
    <alert></alert>
    <form [formGroup]="userForm" (ngSubmit)="onSubmit()" novalidate>

      <!-- Partner Selection -->
      @if (userview !== 'assign') {
        <div class="form-row">
          <div class="col">
            <select class="form-control form-control-sm" formControlName="partner">
              <option value="" selected disabled>Partner*</option>
              @for (partner of partners; track partner) {
                <option [value]="partner.id">{{ partner.name }}</option>
              }
            </select>
          </div>
        </div>
      }

      <!-- Customer Selection -->
      @if (
        userview === 'assign' ||
        userForm.controls.role.value === Role.ReadOnly ||
        userForm.controls.role.value === Role.CustomerAdmin
        ) {
        <div class="form-row">
          @if (userview !== 'assign') {
            <div class="col">
              <select class="form-control form-control-sm" formControlName="customer"
                [ngClass]="{ 'is-invalid': submitted &amp;&amp; userForm.controls.customer.errors }"
                (change)="onCustomerChange($event.target.value)">
                <option selected disabled value="">Select customer*</option>
                @if (userview === 'edit') {
                  <option [value]="assignedCustomer.id">{{assignedCustomer.name}}</option>
                }
                @if (userview !== 'edit') {
                  @for (customer of customersList; track customer) {
                    <option [value]="customer.id">{{customer.name}}</option>
                  }
                }
              </select>
              @if (submitted && userForm.controls.customer.errors) {
                <div class="text-danger">
                  @if (userForm.controls.customer.errors.required) {
                    <div>Customer is required</div>
                  }
                </div>
              }
            </div>
          }
          <!-- Project Selection -->
          @if (userview === 'assign' || userForm.controls.role.value === Role.ReadOnly) {
            <div class="col">
              <angular2-multiselect [data]="dropdownList" formControlName="projects" [settings]="dropdownSettings"
                (onSelect)="onItemSelect($event)" (onDeSelect)="OnItemDeSelect($event)" (onSelectAll)="onSelectAll($event)"
                (onDeSelectAll)="onDeSelectAll($event)">
              </angular2-multiselect>
            </div>
          }
        </div>
      }
      @if (userview !== 'assign') {
        <div class="form-row">
          <div class="col">
            <input type="text" class="form-control form-control-sm" formControlName="email"
              [ngClass]="{ 'is-invalid': submitted &amp;&amp; userForm.controls.email.errors }" placeholder="Email*">
            @if (submitted && userForm.controls.email.errors) {
              <div class="text-danger">
                @if (userForm.controls.email.errors.required) {
                  <div>Email is required</div>
                }
                @if (userForm.controls.email.errors.email) {
                  <div>Invalid email address</div>
                }
              </div>
            }
          </div>
          <div class="col">
            <input class="form-control form-control-sm"
              [ngClass]="{ 'is-invalid': submitted && userForm.controls.phone.errors }" formControlName="phone"
              placeholder="Phone number (ex. +1 555 222 4444)">
            @if (submitted && userForm.controls.phone.errors) {
              <div class="text-danger">
                @if (userForm.controls.phone.errors.phone) {
                  <div>Phone number is invalid (make sure to include country
                  code)</div>
                }
              </div>
            }
          </div>
        </div>
      }

      @if (userview != 'assign') {
        <div class="form-row">
          <div class="col">
            <!-- Role Selection -->
            <select class="form-control form-control-sm" formControlName="role" (change)="onRoleChange()"
              [ngClass]="{ 'is-invalid': submitted &amp;&amp; userForm.controls.role.errors }">
              <option value="" selected disabled>Account Type*</option>
              @if (authService.hasAccess(Role.SuperAdmin)) {
                <option [value]="Role.SuperAdmin">Admin</option>
              }
              @if (authService.hasAccess(Role.PartnerAdmin)) {
                <option [value]="Role.PartnerAdmin">Partner Admin</option>
              }
              @if (authService.hasAccess(Role.CustomerAdmin)) {
                <option [value]="Role.CustomerAdmin">Customer Admin</option>
              }
              <option [value]="Role.ReadOnly">Read Only</option>
            </select>
            @if (submitted && userForm.controls.role.errors) {
              <div class="text-danger">
                @if (userForm.controls.role.errors.required) {
                  <div>User role is required</div>
                }
              </div>
            }
          </div>
          <div class="col">
            <select class="form-control form-control-sm" formControlName="status"
              [ngClass]="{ 'is-invalid': submitted &amp;&amp; userForm.controls.status.errors }">
              <option value="" selected disabled>User Status*</option>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
            @if (submitted && userForm.controls.status.errors) {
              <div class="text-danger">
                @if (userForm.controls.status.errors.required) {
                  <div>User status is required</div>
                }
              </div>
            }
          </div>
        </div>
      }


      @if (!showReturnButton) {
        <div class="form-row">
          <button type="submit" class="btn btn-sm btn-primary" [disabled]="loading">{{buttonTitle}}</button>
          <button (click)="navigateBack()" [style.margin-left.px]="16" type="button"
          class="btn btn-sm btn-outline-secondary" [disabled]="loading">Cancel</button>
        </div>
      }
      @if (showReturnButton) {
        <div class="form-row">
          <a class="btn btn-sm btn-primary" [routerLink]="['/dashboard/user/list']">Done</a>
        </div>
      }
    </form>
  </div>
</div>